import Utils from "../../Shared/Utils";
import Constant from "../../Shared/Constant";
import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class PlayerCenterUI extends cc.Component {
    @property(cc.Node)
    layerBasicInfo: cc.Node = null
    
    @property(cc.Node)
    layerBetRecords: cc.Node = null
    
    @property(cc.Node)
    layerBalanceRecords: cc.Node = null
    
    @property(cc.Widget)
    wgtNode: cc.Widget = null

    private _type2Layer = {}
    private _curLayer = null

    onLoad () {
        this._type2Layer = {
            basicInfo: this.layerBasicInfo,
            betRecords: this.layerBetRecords,
            balanceRecords: this.layerBalanceRecords,
        }

        this.layerBasicInfo.active = false
        this.layerBetRecords.active = false
        this.layerBalanceRecords.active = false
    }

    start () {
        Utils.hideGameNode()
    }

    onDestroy () {
    }

    onBtnClick (event, userData) {
        if (userData === "back") {
            AudioManager.playSound("close")
            Utils.showGameNode()
            this.node.destroy()
        }
    }

    onSelectToggle (toggle) {
        this.showLayer(toggle.userData)
    }

    private showLayer (name) {
        if (this._curLayer) {
            this._curLayer.active = false
        }

        this._curLayer = this._type2Layer[name]
        this._curLayer.active = true
    }
}
